import { normalizeHex } from "./harmonicPalette";

/** Inches of strung beads needed for one inch of finished rope. */
export const STRUNG_PER_ROPE_INCH = 6;

/** Chart rows in one inch of finished rope. Beads around does not change this. */
export const ROWS_PER_ROPE_INCH = 16;

export function normalizeSegmentColor(raw) {
  if (raw == null || raw === "") return "";
  return normalizeHex(String(raw)) || "";
}

export function parseInchInput(raw) {
  if (raw === "" || raw == null) return null;
  const n = Number(String(raw).trim());
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

export function strungInchesFromRope(ropeInches) {
  const n = Number(ropeInches);
  if (!Number.isFinite(n) || n < 0) return 0;
  return n * STRUNG_PER_ROPE_INCH;
}

export function formatInches(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  const rounded = Math.round(n * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

export function normalizeKnotSegments(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map((segment, index) => {
    const rope = Number(segment?.rope);
    return {
      id:
        segment?.id != null && String(segment.id) !== ""
          ? String(segment.id)
          : `seg-${index + 1}`,
      name: typeof segment?.name === "string" ? segment.name : "",
      color: normalizeSegmentColor(segment?.color),
      rope: Number.isFinite(rope) && rope >= 0 ? rope : 0,
    };
  });
}

export function newKnotSegment() {
  return {
    id: `seg-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    name: "",
    color: "",
    rope: 0,
  };
}

export function sumKnotTotals(segments) {
  const rope = normalizeKnotSegments(segments).reduce(
    (total, segment) => total + segment.rope,
    0
  );
  return { rope, strung: strungInchesFromRope(rope) };
}
